import React from 'react';
// import cx from 'classnames';
import BaseModal from '../../common/BaseModal/BaseModal';
import styles from './ExitModal.scss';

// focus handling
import FocusModal from '../../common/FocusModal/FocusModal';
import { FocusDiv } from '#/widgets/ui';
import { TV_CONTENT_MODAL } from '#/utils/navigationHelper';
import { isWorkstation } from '#/utils/componentStyleConfig';
import { exitModalText } from '#/config/strings';

const {
  CONTAINER,
  TV_CONTENT_MODAL_ACTION_BUTTON,
  TV_CONTENT_MODAL_CANCEL_BUTTON,
} = TV_CONTENT_MODAL;

const ExitModal = () => {
  return (
    <FocusModal>
      <BaseModal
        saveButtonText={exitModalText.okBtn}
        saveButtonContainerClassName={styles.okBtn}
        cancelButtonText={exitModalText.cancelBtn}
        cancelButtonContainerClassName={styles.cancelBtn}
        nav={{
          parent: CONTAINER,
          id: TV_CONTENT_MODAL_ACTION_BUTTON,
          nextdown: TV_CONTENT_MODAL_CANCEL_BUTTON,
        }}
        navCancel={{
          parent: CONTAINER,
          id: TV_CONTENT_MODAL_CANCEL_BUTTON,
          nextup: TV_CONTENT_MODAL_ACTION_BUTTON,
        }}
        showCancelButton
        showCloseX={!!isWorkstation}
      >
        <FocusDiv
          className={styles.container}
          nav={{
            id: CONTAINER,
            forwardFocus: TV_CONTENT_MODAL_ACTION_BUTTON,
          }}
        >
          <div>
            <p>{exitModalText.text}</p>
          </div>
        </FocusDiv>
      </BaseModal>
    </FocusModal>
  );
};

export default ExitModal;
